import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import FacingMonitoringDocs from "../facingMonitoring/Docs";
import FacingMonitoringStep1 from "../facingMonitoring/Step1";
import FacingMonitoringStep2 from "../facingMonitoring/Step2";
import FacingMonitoringStep3 from "../facingMonitoring/Step3";
import React from "react";
import * as constants from "../assets/constants";
import {AdaptivityContext} from "../assets/constants";

class FragmentFacingMonitoring extends BaseComponent {
    constructor(props) {
        super(props)
        const state = {
            activePanelFacingMonitoring: 'facingmonitoringdocs_panel',
            current_facing_monitoring_doc: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    clearFacingMonitoringData = (status = constants.CODE_FACING_MONITORING_STATUS_NEW) => {
        localStorage.setItem(constants.values_facing_monitoring_key, "")
        this.setState({current_facing_monitoring_doc: null})

    }

    receiveMessage = (event) => {
        if (event.data.type !== undefined && event.data.type === 'setStep') {

            let newData = {}

            const lowerName = event.data.objectName.toLowerCase()
            newData[`activePanel${event.data.objectName}`] = `${event.data.objectName.toLowerCase()}_step${event.data.numStep}_panel`

            this.setState(newData)
            return
        }
        if (event.data.type !== undefined && event.data.type === 'endFacingMonitoring') {
            this.setState({activePanelFacingMonitoring: 'facingmonitoringdocs_panel',})
            window.postMessage('goToMain')
            this.openLoadingNoty("Документ успешно сохранен", 2000, true)
            setTimeout(() => this.clearFacingMonitoringData(constants.CODE_FACING_MONITORING_STATUS_IN_PROCESS), 1000)
        }

        if (event.data.type !== undefined && event.data.type === 'startFacingMonitoring') {

            if (!event.data.noClearData) {
                this.clearFacingMonitoringData()
            }
            this.setState({
                activePanelFacingMonitoring: !event.data.noClearData ? 'facingmonitoring_step1_panel' : 'facingmonitoring_step2_panel'
            })
            return
        }
        if (event.data.type !== undefined && event.data.type === 'editFacingMonitoring') {

            this.setState({
                activePanelFacingMonitoring: 'facingmonitoring_step1_panel'
            })
            return
        }
        if (event.data.type !== undefined && event.data.type === 'goToFacingMonitoringDocs') {

            if (this.state.current_facing_monitoring_doc) {
                this.clearFacingMonitoringData()
            }

            this.setState({
                activePanelFacingMonitoring: 'facingmonitoringdocs_panel'
            })
            return
        }
        if (event.data.type !== undefined && event.data.type === 'facingMonitoringTypeChanged' && this.state.current_facing_monitoring_doc && this.state.current_facing_monitoring_doc.doc_data) {
            const old = this.state.current_facing_monitoring_doc
            old.doc_data.type_ = event.data.newType
            this.setState({current_facing_monitoring_doc: old})
            return
        }
        if (event.data.type !== undefined && event.data.type === 'facingMonitoringDivisionChanged'
            && this.state.current_facing_monitoring_doc && this.state.current_facing_monitoring_doc.doc_data) {
            const old = this.state.current_facing_monitoring_doc
            old.doc_data.division_id = event.data.newDivision.id
            old.doc_data.division_name = event.data.newDivision.name

            this.setState({current_facing_monitoring_doc: old})

            return
        }
    }

    render() {
        return <View activePanel={this.state.activePanelFacingMonitoring}>
            <Panel id="facingmonitoringdocs_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                    <SplitCol>
                        <FacingMonitoringDocs
                            base_url={this.state.base_url}
                            current_user={this.props.current_user}
                            current_doc={this.state.current_facing_monitoring_doc}
                            select_doc={(doc) => this.setState({current_facing_monitoring_doc: doc})}
                        />
                    </SplitCol>

                </SplitLayout>
            </Panel>

            <Panel id="facingmonitoring_step1_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <FacingMonitoringStep1 base_url={this.state.base_url}
                                               current_doc={this.state.current_facing_monitoring_doc}
                                               current_user={this.props.current_user}
                        />
                    </SplitCol>
                </SplitLayout>

            </Panel>
            <Panel id="facingmonitoring_step2_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <FacingMonitoringStep2 base_url={this.state.base_url}
                                               current_doc={this.state.current_facing_monitoring_doc}
                                               get_vars={this.get_vars}
                                               current_user={this.props.current_user}


                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
            <Panel id="facingmonitoring_step3_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                    <SplitCol>
                        <FacingMonitoringStep3 base_url={this.state.base_url}
                                               current_doc={this.state.current_facing_monitoring_doc}
                                               current_user={this.props.current_user}


                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
        </View>
    }

}

export default FragmentFacingMonitoring